module.exports = __webpack_public_path__ + "static/media/profile1.2b647ef3.png";